/**
 * Step 2 of the NDS Home Drainage Center wizard.
 * Every capacity option is server rendered; this only swaps which one is visible
 * and drives the detail accordions.
 */
function init() {
	document.querySelectorAll('[data-drainage-capacity]').forEach(setup);
}

function setup(root) {
	const state = {
		capacityKey: root.getAttribute('data-default-capacity') || ''
	};

	root.querySelectorAll('[data-drainage-tab]').forEach((tab) => {
		tab.addEventListener('click', () => {
			select(root, state, tab.getAttribute('data-drainage-tab'));
		});
	});

	root.querySelectorAll('[data-drainage-row-toggle]').forEach((toggle) => {
		toggle.addEventListener('click', () => toggleRow(toggle));
	});

	applyQueryString(root, state);
}

/**
 * The server renders the configured default, so a visitor arriving back from step 3
 * needs the option named in ?capacity= restored.
 */
function applyQueryString(root, state) {
	const requested = new URLSearchParams(window.location.search).get('capacity');

	if (!requested || requested === state.capacityKey) return;
	if (!root.querySelector('[data-drainage-scope="' + cssEscape(requested) + '"]')) return;

	select(root, state, requested);
}

function select(root, state, key) {
	if (!key || key === state.capacityKey) return;

	state.capacityKey = key;

	root.querySelectorAll('[data-drainage-scope]').forEach((el) => {
		setHidden(el, el.getAttribute('data-drainage-scope') !== key);
	});

	root.querySelectorAll('[data-drainage-tab]').forEach((tab) => {
		const isActive = tab.getAttribute('data-drainage-tab') === key;

		tab.classList.toggle('is-active', isActive);
		tab.setAttribute('aria-selected', String(isActive));
	});

	//detail rows are per option, so anything left open would reveal the wrong copy
	root.querySelectorAll('[data-drainage-row]').forEach((row) => closeRow(row));

	syncUrl(key);
}

function toggleRow(toggle) {
	const row = toggle.closest('[data-drainage-row]');

	if (!row) return;

	const willOpen = !row.classList.contains('is-open');

	if (!willOpen) {
		closeRow(row);
		return;
	}

	const detail = row.querySelector('[data-drainage-row-detail]');

	row.classList.add('is-open');
	toggle.setAttribute('aria-expanded', 'true');
	setHidden(detail, false);
}

function closeRow(row) {
	const toggle = row.querySelector('[data-drainage-row-toggle]');

	row.classList.remove('is-open');

	if (toggle) toggle.setAttribute('aria-expanded', 'false');

	setHidden(row.querySelector('[data-drainage-row-detail]'), true);
}

function setHidden(el, hidden) {
	if (!el) return;

	if (hidden) {
		el.setAttribute('hidden', '');
	} else {
		el.removeAttribute('hidden');
	}
}

/**
 * Keeps ?capacity= in the address bar so the browser back button from step 3
 * restores the option the visitor was looking at.
 */
function syncUrl(key) {
	if (!window.history || !window.history.replaceState) return;

	const url = new URL(window.location.href);

	url.searchParams.set('capacity', key);
	window.history.replaceState({}, '', url.toString());
}

function cssEscape(value) {
	return window.CSS && window.CSS.escape ? window.CSS.escape(value) : value.replace(/"/g, '\\"');
}

export { init };
